

export function RangeBoundary({
    label,
    value,
    valueRef,
}: {
    label: string;
    value: string;
    valueRef: React.RefObject<HTMLElement | null>;
}) {
    return (
        <div className='report-range-dialog__boundary'>
            <span>{label}:</span>
            {/* The calendar's pointer preview writes its suggested Start/End date through this ref. */}
            <strong ref={valueRef}>{value}</strong>
        </div>
    );
}
